export enum LayoutTypesEnum {
    IMAGE_AND_DATA = 'imageAndData',
    DATA = 'data',
}